/**
 * @module components\TxnHistory
 */
import Vue from "vue";
import Component from "vue-class-component";
import { required } from "vuelidate/lib/validators";
import _ from "lodash";
import VueLoadingButton from "vue-loading-button";
import _buffer from "buffer";
import store from "@/store";
import core from "@/services/core";
import utilities from "@/utilities";
import LoaderMobile from "@/services/loaderMobile";
import sToast from "@/services/sToast";
import stoast from "@/services/sToast";
import * as XLSX from "xlsx/dist/xlsx.full.min.js";
@Component({
  components: {
    VueLoadingButton,
  },
  validations: {
    requestKey: { required },
    displayName: { required },
  },
})
export default class uploadMaster extends Vue {
  isButtonLoading = false;
  buttonText = "Submit";
  depositFile: any = [];
  itemsModules = ["Commission Configuration"];
  masterDataTypes = [
    "Sample File",
    "Plan ID Master",
    "Plan Name Master",
    "SMA Plan Master",
    "Client ID & AggID Master",
  ];
  action: "";
  active = 0;
  fileDataType = "upload";
  fileSize = 0;
  fileDataTypes = [{ displayName: "Upload", value: "upload" }];
  rules = [];
  requestForKey = [];
  requestKey = "COMMISSION_UPLOAD";
  displayNames = [];
  displayName = "";
  serviceId = [];
  serviceName = [];
  tabKey = [];
  downlaodResponse = "";
  commUploadFileType = null;

  isValidFile() {
    if (
      this.depositFile &&
      (this.depositFile["type"] == "application/vnd.ms-excel" ||
        this.depositFile["type"] ==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") &&
      this.depositFile["size"] < this.fileSize * 1000000
    ) {
      return false;
    }
    return true;
  }
  get staticData() {
    return store.getters.staticDataGet;
  }
  tab = store.getters.tabKeyGet.tab;

  downloadRevFile(type) {
    this.commUploadFileType = this.getcommUploadFileType(this.displayName);

    let request = {
      transactionId: "",
      token: store.getters.sessLoginDataGet.sessionId,
      merchantClientId: store.getters.sessLoginDataGet.clientId,
      requestType: "WEB",
      requestModule: "CMS",
      requestKey: "",
      aggId: "",
      tabKey: this.commUploadFileType.tabKey,
      requestId: "",
      serviceId: this.commUploadFileType.serviceId,
      serviceName: this.commUploadFileType.serviceName,
      requestFor: this.requestKey,
    };
    core
      .post({
        data: request,
        url: "demandDownload",
        method: "post",
      })
      .then((response) => {
        utilities.downloadFileFromB64(
          response.payload.fileByte,
          response.payload.udf4 ? `${response.payload.udf4}` : "Sample.xlsx"
        );
      })
      .catch((error) => {
        
      });
  }
  mounted() {
    if (this.tab == "UPLOAD_COMM") {
      this.requestForKey = this.staticData.payload.commUploadFileType.map(
        (item) => item.requestForKey
      );
      this.displayNames = this.staticData.payload.commUploadFileType.filter(
        (item) => item.displayName
      );

      let filterList = this.staticData.payload.versionInfos.filter((el) => {
        return el["keyName"] == "uploadMasterFileSize";
      });

      if (filterList.length > 0) {
        this.fileSize = filterList[0]["keyValue"];
      }

      this.rules = [
        (value) => !!value || "File is required",
        (value) =>
          (!!value && value.size < this.fileSize * 1000000) ||
          `File size should be less than ${this.fileSize} MB `,
        (value) =>
          (!!value &&
            (value.type ==
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
              value.type == "application/vnd.ms-excel")) ||
          "Please upload a valid file",
      ];
      this.itemsModules = _.orderBy(
        this.staticData.payload.uploadMasterModule,
        "displayName"
      ).filter((el) => {
        return el.key == "UPLOAD_COMM";
      });
      if (this.itemsModules.length == 1) {
        this.requestKey = this.itemsModules[0]["value"];
        this.setFileTypes();
      }
    }
  }

  checkMgNumber() {
    if (this.active == 0) {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
    } else {
      if (this.$v.requestKey.$invalid || this.$v.displayName.$invalid) {
        this.$v.$touch();
        return;
      }
    }
    const filereader = new FileReader();
    filereader.onloadend = (event: any) => {
      if (event.target.readyState === FileReader.DONE) {
        this.checkExtensions(this.depositFile, event);
      }
    };
    const blob: any = this.depositFile.slice(0, 4);
    filereader.readAsArrayBuffer(blob);
  }
  checkExtensions(file: any, eventReader: any) {
    const uint = new Uint8Array(eventReader.target.result);
    const bytes: any = [];
    uint.forEach((byte: any) => {
      bytes.push(byte.toString(16));
    });
    const hex = bytes.join("").toUpperCase();
    let scannedFileType = this.getMimetype(hex, this.depositFile["type"]);
    if (scannedFileType == "Unknown filetype") {
      this.showFileErrorMsg();
      return;
    }
    //this.uploadFile(file: any,eventReader: any);
    this.checkFilesHeaders(file, eventReader);
  }
  showFileErrorMsg() {
    sToast.show({
      message: "Please upload a valid file",
      intent: "error",
      timeout: 6000,
    });
  }
  getMimetype = (signature: any, type: string) => {
    if (signature === "504B34") {
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    } else {
      return "Unknown filetype";
    }
  };

  get metadata() {
    let fileFormatClient = this.staticData.payload.commFileFormats.filter(
      (obj) => {
        return (
          obj.serviceName == this.requestKey &&
          obj.requestFor == this.displayName
        );
      }
    );

    if (fileFormatClient.length > 0) {
      return fileFormatClient[0]["metaData"];
    } else {
      return []; // or any default value you prefer if fileFormatClient is empty
    }
  }

  fileFormats() {
    let validColumn = [];
    if (this.staticData.payload.commFileFormats && this.requestKey) {
      let fileFormatClient = this.staticData.payload.commFileFormats.filter(
        (obj) => {
          return (
            obj.serviceName == this.requestKey &&
            obj.requestFor == this.displayName
          );
        }
      );
      if (fileFormatClient.length > 0) {
        let clientMeta = _.orderBy(fileFormatClient[0]["metaData"], "order");
        for (let i = 0; i < clientMeta.length; i++) {
          validColumn.push(clientMeta[i].colName);
        }
      }
    }
    return validColumn;
  }

  checkFilesHeaders(file: any, eventReader: any) {
    this.isButtonLoading = true;
    this.buttonText = "Validating the file...";

    let reader1 = new FileReader();
    reader1.onload = (e) => {
      let fileValid = [];
      fileValid = this.fileFormats(); //["Branch ID", "Branch Name", "Delivery Date(DD-MM-YYYY)", "Amount"];
      var workbook = XLSX.read(e.target.result, {
        cellDates: true,
        type: "binary",
      });
      let first_sheet_name = workbook.SheetNames[0];
      let worksheet = workbook.Sheets[first_sheet_name];
      let xlsData = XLSX.utils.sheet_to_json(worksheet, { header: "A" });
      let isHeaders = false;
      if (xlsData.length) {
        let xlsKeys = Object.values(xlsData[0]);
        if (fileValid.length == xlsKeys.length) {
          isHeaders = false;
          for (let i = 0; i < fileValid.length; i++) {
            if (!fileValid.includes(xlsKeys[i]) && !isHeaders) {
              isHeaders = true;
            }
          }
        } else {
          isHeaders = true;
        }
      } else {
        isHeaders = true;
      }
      if (isHeaders) {
        this.isButtonLoading = false;
        this.buttonText = "Submit";
        this.showFileErrorMsg();
        return;
      }
      this.isButtonLoading = false;
      this.buttonText = "Submit";
      this.uploadFile();
    };
    reader1.readAsBinaryString(file);
  }
  get reqModule() {
    return store.getters.tabKeyGet.requestModule;
  }
  

  uploadFileRes = null;
  uploadFile() {
    this.commUploadFileType = this.getcommUploadFileType(this.displayName);
    const formData = new FormData();
    formData.append("token", store.getters.sessLoginDataGet.sessionId);
    formData.append("requestModule", "CMS");
    formData.append("requestType", "WEB");
    formData.append(
      "merchantClientId",
      store.getters.sessLoginDataGet.clientId
    );
    formData.append("requestFor", this.displayName);
    formData.append("aggId", ""); //Select box added on UI for dynamic clients and aggId
    formData.append("requestKey", this.requestKey);
    formData.append("tabKey", "UPLOAD_COMM");
    formData.append("file1", this.depositFile);
    formData.append("serviceId", this.commUploadFileType.serviceId);
    formData.append("serviceName", this.commUploadFileType.serviceName);
    formData.append("action", this.active == 0 ? "ADD" : "REMOVE");
    formData.append("fileDataType", this.active == 1 ? "" : this.fileDataType);
    core
      .post({
        data: formData,
        url: "commissionUploadDataMaster",
        method: "POST",
      })
      .then((response: any) => {
        this.uploadFileRes = response;
        if (response.payload.errorFileFlag) {
          utilities.downloadFileFromB64(
            response.payload.errorfile1,
            response.payload.udf4 ? `${response.payload.udf4}` : "Error.xlsx"
          );
          this.showSuccessWarning(response);
        } else {
          this.resetFields();
          this.showUploadSuccess(response);
          this.active = 0;
        }
      })
      .catch((error: any) => {
        LoaderMobile.hide();
        if (error.data.payload.errorFileFlag) {
          utilities.downloadFileFromB64(
            error.data.payload.errorfile1,
            error.data.payload.udf4
              ? `${error.data.payload.udf4}`
              : "Error.xlsx"
          );
          this.showWarning(error);
        } else this.showUploadError(error);
      });
  }

  showSuccessWarning(response) {
    sToast.show({
      message: response.responseDesc,
      intent: "warning",
      timeout: 6000,
    });
  }
  showUploadSuccess(response) {
    stoast.show({
      message: response.responseDesc,
      intent: "success",
      timeout: 8000,
    });
  }
  showUploadError(response) {
    sToast.show({
      message: response.data.responseDesc,
      intent: "error",
      timeout: 6000,
    });
  }
  showWarning(response) {
    sToast.show({
      message: response.data.responseDesc,
      intent: "warning",
      timeout: 6000,
    });
  }
  setFileTypes() {
    {
      this.displayName = "";
      this.fileDataType = "";
      this.active = 0;
      this.$refs["file"].reset();
      let masterDataTypes = [];
      masterDataTypes = this.staticData.payload.uploadFileType.filter((el) => {
        return el.tabKey == "UPLOAD_COMM" && el.value == this.requestKey;
      });
      masterDataTypes = _.orderBy(masterDataTypes, "displayName");
      this.masterDataTypes = masterDataTypes;
      if (masterDataTypes.length == 1) {
        this.displayName = masterDataTypes[0]["requestFor"];
      } else {
        this.displayName = "";
      }
    }
  }
  resetFields() {
    this.depositFile = [];
    this.requestKey = "";
    this.displayName = "";
    this.fileDataType = "";
    this.active = 0;
    this.$refs["file"].reset();
    //this.$refs['form'].reset();
    this.$v.$reset();
  }

  getcommUploadFileType(displayName) {
    return this.staticData.payload.commUploadFileType.find(
      (el) => el.serviceName === displayName
    );
  }
}
